import { ActionCreatorBase } from 'Widgets/Scripts/ModernWidgetTypes/ActionCreatorBase';

export class AnalyticsTrendsActionCreator extends ActionCreatorBase {}